import { defineMessages } from 'react-intl-next';

export default defineMessages({
	customPageFormSaveButtonText: {
		defaultMessage: 'Save',
		description: 'Custom Page form save button text',
		id: 'create.custom.page.form.save.button.text',
	},
	customPageFormCancelButtonText: {
		defaultMessage: 'Cancel',
		description: 'Custom Page form cancel button text',
		id: 'create.custom.page.form.cancel.button.text',
	},
	customPageFormCreateButtonText: {
		defaultMessage: 'Create',
		description: 'Custom Page form create button text',
		id: 'create.custom.page.form.create.button.text',
	},
	customPageFormDuplicateButtonText: {
		defaultMessage: 'Duplicate',
		description: 'Custom Page form duplicate button text',
		id: 'create.custom.page.form.duplicate.button.text',
	},
});
